import { cn } from '@worldcoo/ui/lib/utils';
import { Image } from '@/routes/-components/image';

/** The current `www` site's 96x48 plate, ported by TEC-3821 B3. */
const BOX_ASPECT = 2;

/** Static class names so Tailwind sees them; `height` repeats the number for the CDN request. */
const SIZES = {
	sm: { box: 'h-10 max-w-20', image: 'max-h-10', height: 40 },
	md: { box: 'h-12 max-w-24', image: 'max-h-12', height: 48 },
	lg: { box: 'h-16 max-w-32', image: 'max-h-16', height: 64 },
	xl: { box: 'h-20 max-w-40', image: 'max-h-20', height: 80 },
} as const;

export type PartnerLogoSize = keyof typeof SIZES;

/**
 * One box proportion everywhere, since record artwork shares no size, aspect or padding; a surface picks
 * only the box size. The worst source files still need replacing in the backoffice (Comms). Full colour:
 * the September 2026 review read greyscale as making partners faint.
 */
export function PartnerLogo(props: {
	src: string | undefined;
	alt: string;
	size: PartnerLogoSize;
	/** For a logo that arrives on a moving belt. */
	eager?: boolean;
	className?: string;
}) {
	const size = SIZES[props.size];
	return (
		<span className={cn('flex w-full items-center justify-center', size.box, props.className)}>
			<Image
				src={props.src}
				alt={props.alt}
				height={size.height}
				aspectRatio={BOX_ASPECT}
				objectFit="contain"
				eager={props.eager}
				className={cn('w-full object-contain!', size.image)}
			/>
		</span>
	);
}
